let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3P6s9")).then(() => parcelRequire('dWUED'));